module.exports = __webpack_public_path__ + "img/single-neutral.4b4eef34.svg";